module.exports = __webpack_public_path__ + "img/矩形1778.4aa5e86a.png";